import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";

export default function PoliticaPrivacidad() {
  return (
    <LegalLayout title="Política de privacidad" updated="Versión 1.0 · septiembre de 2026">
      <div data-testid="legal-privacidad">
        <P>
          Esta política explica cómo se tratan los datos personales en el sitio web y en el servicio DDP · Datos · Decisión ·
          Posición. Es importante distinguir dos planos de tratamiento con roles distintos, que se describen a continuación.
        </P>

        <H2>Dos planos de tratamiento</H2>
        <P>
          <strong>A. Datos respecto de los que DDP es responsable del tratamiento.</strong> Corresponden a la relación del
          titular con el solicitante y el despacho: solicitudes de acceso, datos de contacto profesional, gestión de cuentas
          autenticadas, comunicaciones, registros de seguridad y acceso, y administración de la relación con el despacho.
        </P>
        <P>
          <strong>B. Documentación y datos personales contenidos en los expedientes.</strong> Respecto de la documentación
          judicial y de los datos personales que esta contenga, el despacho sigue siendo el responsable del tratamiento y DDP
          actúa como <strong>encargado del tratamiento</strong>, tratando dicha documentación siguiendo las instrucciones del
          despacho. Este tratamiento requiere la formalización de un contrato de encargo de tratamiento (acuerdo de tratamiento
          de datos) independiente antes de remitir documentación real de expedientes.
        </P>

        <H2>1. Responsable del tratamiento</H2>
        <UL>
          <li><strong>Responsable:</strong> José Carlos Moraleda García.</li>
          <li><strong>NIF:</strong> 15471973B.</li>
          <li><strong>Domicilio:</strong> Almería, España, 04006.</li>
          <li><strong>Contacto en materia de privacidad:</strong> jcmgjurista@gmail.com · +34 627225405.</li>
        </UL>

        <H2>2. Categorías de datos tratados</H2>
        <UL>
          <li>Datos identificativos y de contacto profesional: nombre y apellidos, despacho, correo electrónico profesional y, en su caso, teléfono y área de práctica.</li>
          <li>Datos de la cuenta autenticada y de gestión de la relación (por ejemplo, invitaciones y estado de acceso).</li>
          <li>Datos de las comunicaciones que usted mantenga con el titular.</li>
          <li>Registros técnicos de seguridad y acceso (eventos de autenticación, subida y descarga de documentos, cambios de estado y acciones de administración).</li>
          <li>Documentación de los expedientes que el despacho decida remitir, que puede contener datos personales de terceros (véase el apartado sobre categorías especiales).</li>
        </UL>

        <H2>3. Finalidades del tratamiento</H2>
        <UL>
          <li>Gestionar y valorar las solicitudes de acceso al piloto.</li>
          <li>Contactar con el solicitante y administrar el acceso profesional a DDP.</li>
          <li>Prestar el servicio: recepción de asuntos, seguimiento de su estado y entrega de la Hoja de Pronóstico.</li>
          <li>Garantizar la seguridad, la trazabilidad y el correcto funcionamiento del servicio.</li>
          <li>Atender las comunicaciones y cumplir las obligaciones legales aplicables.</li>
        </UL>

        <H2>4. Bases jurídicas</H2>
        <P>
          El tratamiento de los datos de solicitud, cuenta y prestación del servicio se basa en la aplicación de medidas
          precontractuales y en la ejecución de la relación con el despacho. La seguridad y la trazabilidad del servicio se
          amparan en el interés legítimo del responsable en proteger la información y prevenir usos indebidos. El cumplimiento
          de obligaciones legales constituye la base cuando resulte aplicable. La aceptación de esta política al enviar la
          solicitud no se utiliza como base de consentimiento para finalidades comerciales. Respecto de la documentación de los
          expedientes, la base la determina el despacho como responsable, y DDP la trata conforme al encargo de tratamiento.
        </P>

        <H2>5. Destinatarios y proveedores</H2>
        <P>
          Los datos no se ceden a terceros salvo obligación legal. Para prestar el servicio, el titular puede apoyarse en
          proveedores tecnológicos que actúan como encargados de tratamiento (por ejemplo, infraestructura de alojamiento y
          almacenamiento, y envío de correos transaccionales). Estos proveedores tratan los datos únicamente conforme a las
          instrucciones del titular. La relación actualizada de proveedores que actúan como encargados de tratamiento se
          facilita a los despachos en el marco del acuerdo de tratamiento de datos y puede solicitarse en cualquier momento a
          través del contacto de privacidad.
        </P>

        <H2>6. Transferencias internacionales</H2>
        <P>
          Los datos se alojan y tratan en servidores situados en la Unión Europea. No se realizan transferencias
          internacionales de datos fuera del Espacio Económico Europeo. Si en el futuro fuera necesario recurrir a un proveedor
          que implique tales transferencias, solo se hará con las garantías exigidas por la normativa aplicable y se comunicará
          previamente a los despachos afectados.
        </P>

        <H2>7. Criterios de conservación</H2>
        <P>
          Los datos de solicitud y de la cuenta se conservan mientras se mantenga la relación y el acceso al piloto, y
          posteriormente durante los plazos necesarios para atender responsabilidades legales. Los registros de seguridad se
          conservan durante el tiempo proporcionado a su finalidad. La documentación de los expedientes se conserva conforme a
          lo pactado en el acuerdo de tratamiento con el despacho y se elimina o devuelve al finalizar el encargo.
        </P>

        <H2>8. Seguridad y confidencialidad</H2>
        <P>
          El acceso es autenticado y cada despacho accede únicamente a sus propios asuntos. La documentación se almacena de
          forma privada, sin enlaces públicos permanentes, y las descargas requieren autenticación y autorización. La Hoja de
          Decisión se entrega dentro de la plataforma y nunca como adjunto por correo. Se aplican medidas técnicas y
          organizativas proporcionadas para proteger la información.
        </P>

        <H2>9. Cuentas autenticadas y registros de acceso</H2>
        <P>
          La gestión de la cuenta incluye el mantenimiento de las credenciales de acceso y de los registros técnicos de
          autenticación y actividad estrictamente necesarios para la seguridad y la trazabilidad. No se registran contraseñas ni
          tokens en claro, ni el contenido íntegro de los documentos, ni el análisis jurídico completo.
        </P>

        <H2>10. Documentación de los expedientes</H2>
        <P>
          La documentación de los expedientes es responsabilidad del despacho. DDP la trata como encargado, siguiendo sus
          instrucciones y con la única finalidad de prestar el servicio contratado. Debe existir un acuerdo de tratamiento de
          datos formalizado antes de remitir documentación real.
        </P>

        <H2>11. Posibles categorías especiales de datos</H2>
        <P>
          Los expedientes judiciales pueden contener datos de categorías especiales, incluidos datos de salud, así como datos
          relativos a infracciones o condenas. El despacho debe valorar la necesidad y la proporcionalidad de la información
          aportada y aplicar el proceso DDP Privacy acordado antes de subir la documentación.
        </P>

        <H2>12. Uso al que NO se destinan los expedientes ni los análisis</H2>
        <P>Los documentos de los expedientes y los análisis DDP no se utilizan para:</P>
        <UL>
          <li>publicidad;</li>
          <li>finalidades ajenas a la prestación del servicio;</li>
          <li>demostraciones públicas;</li>
          <li>entrenamiento de modelos;</li>
          <li>creación de conjuntos de datos no relacionados.</li>
        </UL>

        <H2>13. Derechos de las personas interesadas</H2>
        <P>
          Puede ejercer los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad,
          así como retirar en su caso el consentimiento, dirigiéndose a{" "}
          <a href="mailto:jcmgjurista@gmail.com" style={{ color: "var(--burgundy)", fontWeight: 600 }}>jcmgjurista@gmail.com</a>.
          Cuando los datos formen parte de la documentación de un expediente, el ejercicio de derechos se canalizará a través del
          despacho responsable. Asimismo, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de
          Datos (www.aepd.es) si considera que el tratamiento no se ajusta a la normativa.
        </P>
      </div>
    </LegalLayout>
  );
}
